<template>
	<div class="footer-customer-care">
		<div class="footer-customer-care__title">Need Help?</div>
		<div class="footer-customer-care__wrapper">
			<div class="footer-customer-care__link-wrapper">
				<icon name="phone" class="footer-customer-care__icon" />
				<a href="tel:+1-800-210-2370" class="footer-customer-care__link">
					1-800-210-2370
				</a>
			</div>
			<div class="footer-customer-care__link-wrapper">
				<icon name="email" class="footer-customer-care__icon" />
				<a href="/customer-care/" class="footer-customer-care__link">
					Email Us
				</a>
			</div>

			<div class="footer-customer-care__link-wrapper">
				<icon name="edit" class="footer-customer-care__icon" />
				<button @click="showMedallia" class="btn-reset medallia-button footer-customer-care__link">
					Submit Feedback
				</button>
			</div>
		</div>
	</div>
</template>

<script>
import Icon from 'JS/components/Icon.vue';

export default {
	name: 'CustomerCare',
	components: {
		Icon
	},
	methods: {
		showMedallia() {
			if (KAMPYLE_ONSITE_SDK) KAMPYLE_ONSITE_SDK.showForm(6655);
			else alert("A browser extension appears to be blocking this feature!");
		}
	}
};

</script>

<style lang='less'>
@import '../../../../less/_mixins.less';

.footer-customer-care {

	&__title {
		font-size: 0.875rem;
		font-weight: bold;
		line-height: 1;
		margin-bottom: 8px;

		.tablet-and-up-styles({
			display: none;
		});
	}

	&__wrapper {
		display: flex;
		justify-content: space-between;
		flex-direction: column;
		gap: 7px;

		.styles-at-min(360px, {
			flex-direction: row;
		});

		.tablet-and-up-styles({
			flex-direction: column;
		})
	}

	&__link-wrapper {
		display: flex;
		align-items: center;
		gap: 4px;

		.tablet-and-up-styles({
			gap: 6px;
		})
	}

	&__link {
		color: black;
		text-decoration: none;
		font-size: 0.75rem;
		line-height: 1 !important;
		text-wrap: nowrap;
		margin-bottom: 0px !important;

		.tablet-and-up-styles({
			font-size: 0.875rem;
		});
	}

	&__icon {
		font-size: 16px;

		.tablet-and-up-styles({
			font-size: 18px;
		});
	}
}

</style>